/* FizzyIQ — Foundation cards (fnc-). v2 2026-09-01: the flip logic
   retired with the redesign; this is the clicked-state toggle for the
   Figma 4557 expanded card. One card open at a time; the .fnc-toggle
   button handles Enter and Space, Escape closes an open card, and
   aria-expanded stays synced on the button, which is the element that
   carries the expanded state. */
(function () {
  'use strict';

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll('.fnc-card[data-card]'));
  }

  function setOpen(card, open) {
    card.classList.toggle('is-open', open);
    var back = card.querySelector('.fnc-back');
    if (back) back.setAttribute('aria-hidden', open ? 'false' : 'true');
    var btn = card.querySelector('.fnc-toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggle(card) {
    var willOpen = !card.classList.contains('is-open');
    cards().forEach(function (c) { if (c !== card) setOpen(c, false); });
    setOpen(card, willOpen);
  }

  function init() {
    cards().forEach(function (card) {
      if (card.dataset.fncInit === '1') return;
      card.dataset.fncInit = '1';
      // Pointer users can still click anywhere on the card; the .fnc-toggle
      // button's own click bubbles here, so it needs no separate binding.
      // Enter and Space are the button's own behaviour now, so only Escape
      // is handled here.
      card.addEventListener('click', function () { toggle(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setOpen(card, false);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
